const lbDateSelect = angular.module('app.lbDateSelect', []);

lbDateSelect.controller('lbDateSelectCtrl', require('./lbDateSelectCtrl'));
lbDateSelect.component('lbDateSelect', require('./lbDateSelect'));

export default lbDateSelect;



// WEBPACK FOOTER //
// ./src/components/lbDateSelect/index.js